import { Box } from "@tokenterminal/ui/Box"
import { contentSectionCss } from "components/v3/ContentSection/ContentSection.css"
import { Footer } from "components/v3/Footer"
import { Header } from "components/v3/Header/Header"
import SocketProvider from "context/SocketContext"
import { type ReactElement } from "react"

export function V3Layout(page: ReactElement) {
  return (
    <div className="h-auto md:h-screen flex flex-col gap-0">
      <Header />
      <SocketProvider>
        <Box className={contentSectionCss} as="main" paddingX="2x">
          {page}
        </Box>
      </SocketProvider>
      <Footer />
    </div>
  )
}
